export enum DiscountType {
  Percentage = 'percentage',
  FixedProduct = 'fixed_amount',
  FixedCart = 'fixed_cart',
}
